const comMeta = { lang: 'zh' }

const salonTax = [
  {
    path: '/salon-tax',
    name: `salon-tax`,
    component: () => import('@/views/salonTax'),
    meta: {
      ...comMeta,
      title: '财税沙龙',
      metaInfo: {
        title: '华盟·税纪云 _财税沙龙'
      }
    }
  },
  {
    path: '/salon-tax-forum/detail/:id',
    name: `salon-tax-forum`,
    component: () => import('@/views/salonTax/salonTaxForum/salonTaxForumDetail'),
    meta: {
      ...comMeta,
      title: '互动论坛详情'
    }
  },
  {
    path: '/salon-case/detail/:id',
    name: `salon-case`,
    component: () => import('@/views/salonTax/salonCase/salonCaseDetail'),
    meta: {
      ...comMeta,
      title: '互动论坛详情'
    }
  }
]

export default salonTax



// WEBPACK FOOTER //
// ./src/router/modules/salon-tax.js